import { Pipe, PipeTransform } from '@angular/core';
import moment from 'moment';

@Pipe({
  name: 'customDate'
})
export class CustomDatePipe implements PipeTransform {

  transform(value: Date | string | number | null | undefined): string {
    if (!value) return '';

    return moment(value).format('D MMM YYYY');
  }
}
